// Icon
import { useMemo, useState } from "react";
import { SortableContext, useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import useAppState from "../../context/useAppState";
import Card from "./Card";
import dummyCardImg from "../../assets/images/dummy-card-1.png";
import plsuIcon3 from "../../assets/images/plus-icon-3.svg";
import allImgPaths from "assets/images";
import { ROLES } from "utils/constant";

function Block(props: any) {
  const { eventFetchedData } = useAppState("eventData");
  const {
    cardAnimation,
    openCardAnimation,
    selectedCardIndex,
    selectedCardDetail,
    setState: setCardWrapperState,
    cards : cardList,
    columns,
    updateState

  } =
    useAppState("cardWrapper");

  const { editMode, setEditMode } = useAppState("blockWrapper");
  const { column, createCard, cards, deleteCard, updateCard, selectedCardId, setSelectedCardId } =
    props;

  const [activeBlock, setactiveBlock] = useState(false);
  const [saveActiveBlock, setsaveActiveBlock] = useState(false);

  const cardIds = useMemo(() => {
    return cards.map((task: any) => task.id);
  }, [cards]);

  const isTouchDevice = 'ontouchstart' in window || 'ontouchstart' in document.documentElement;
  const { setNodeRef, attributes, listeners, transform, transition, isDragging } = useSortable({
    id: column.id,
    data: {
      type: "Column",
      column,
    },
    disabled: isTouchDevice ? true : editMode,
	
  });

  const style = {
    // transition,
    // transform: CSS.Transform.toString(transform),
  };

  if (isDragging) {
    return (
      <div
        ref={setNodeRef}
        style={style}
        className="bg-white border border-[#F154FF] rounded-2xl w-[420px] h-full touch-none"
      ></div>
    );
  }

  const getCard = (cardDetail: any) => {
    return (
      <Card
        key={cardDetail.id}
        card={cardDetail}
        createCard={createCard}
        deleteCard={deleteCard}
        updateCard={updateCard}
        onSelect={props.onSelect}
        isCardSelected={selectedCardIndex === cards?.indexOf(cardDetail)}
        onSelectCard={() => setCardWrapperState({ selectedCardIndex: cards?.indexOf(cardDetail) })}
        selectedCardId={selectedCardId}
        setSelectedCardId={setSelectedCardId}
        saveActiveBlock={saveActiveBlock}
        title={column?.title}
        columnId={column?.id}
      />
    )
  }

  const toggleCards = (title: any) => {
    const _cardList = [...cardList];
    const copyColumns = [...columns];
    const index = copyColumns.findIndex((col) => col.id === column.id);

    if (index >= 0) {
      copyColumns[index].isSelected = !copyColumns[index].isSelected;

      _cardList.map((item: any) => {
        if (column.id === item.columnId) {
          item.isSelected = copyColumns[index].isSelected;
        }
      });
    }
    updateState({ column: copyColumns, cards: _cardList });
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      key={column.id}
      className={`bg-white border-2 border-[#F154FF] rounded-2xl w-[360px] touch-none h-max card-anim-block relative  ${openCardAnimation && props.isSeletcted ? "selected" : ""
        }`}
    >
      <div className="px-4 pt-4 pb-3">
        <img
          className="rounded-2xl h-[268px] w-[388px] object-cover"
          src={column.image ? column?.image : dummyCardImg}
          alt=""
        />
      </div>
      <div className="px-4 pb-2 flex items-center justify-between">
        <h5 className="font-interSemiBold text-lg text-[#101828] pl-0.5">{column?.title}</h5>
        <div className="flex items-center gap-x-2 mr-0.5">
          {eventFetchedData?.eventRole?.name === ROLES.OWNER &&
            <div className="relative">
              {!saveActiveBlock && <span onClick={() => setactiveBlock(!activeBlock)} className={`w-6 h-6 rounded hover:bg-[#f2f4f7] ${activeBlock ? "bg-[#f2f4f7]" : ""} flex items-center justify-center`}>
                <img className="w-5 h-5" src={allImgPaths.threeDotsHorizontalIcons} />
              </span>}

              {/* Save Cancel checks */}
              {saveActiveBlock && <div className="flex items-center gap-x-2.5">
                <div onClick={() => { setsaveActiveBlock(false) }} className="flex items-center gap-x-1.5 hover:bg-[#f2f4f7] px-1 py-0.5 rounded">
                  <img className="w-2.5 h-2.5" src={allImgPaths.closeIcon} alt="" />
                  <span className="text-sm font-interSemiBold text-[#61646C]">Exit</span>
                </div>
              </div>}

              {/* Activate and Deactivate dropdowns */}
              {activeBlock && <div className="absolute border rounded-lg bg-white transform px-0.5 py-0.5 shadow-customShadow6 w-60 z-20 right-0 top-full mt-1">
                <div onClick={() => { setsaveActiveBlock(true); setactiveBlock(false) }} className='px-2.5 py-1 flex items-center'>
                  <img src={allImgPaths.toggleIcon} alt="" />
                  <span className="font-interMedium text-sm text-[#344054] block smoothness rounded-md px-2 py-1 cursor-pointer hover:text-[#1e0af5]">Activate/Deactivate Cards</span>
                </div>
              </div>}
            </div>}
          <span onClick={() => toggleCards(column?.title)}>
            <img className={`w-[24px] transition-all duration-500 transform hover:bg-[#f2f4f7] rounded ${column.isSelected && 'rotate-ver'} ${column?.title}-name`} src={allImgPaths.downArrowIcon5} alt="" />
          </span>
        </div>

      </div>
      <div className="px-4">
        {/* Card-Section */}
        {cardAnimation && selectedCardDetail && (
          getCard(selectedCardDetail)
        )}
        <SortableContext items={cardIds}>
          {cards &&
            cards.length > 0 &&
            cards.map((card: any, index: number) => {
              if (cardAnimation) {
                if (selectedCardDetail?.id !== card?.id) {
                  return getCard(card)
                }
              } else {
                return getCard(card)
              }
            })}
        </SortableContext>
        {/* <button
          onClick={() => {
            createCard(column.id);
          }}
          className="border border-[#D0D5DD] rounded-lg px-4 py-3 flex items-center gap-x-2 w-full shadow-customShadow3 mb-4 justify-center"
        >
          <img src={plsuIcon3} alt="" />
          <span className="font-interMedium text-base text-[#1A1F27] ">Add New</span>
        </button> */}
      </div>
    </div>
  );
}
export default Block;
